import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[verticalCollapse]'
})
export class AnimationCollapseVerticalDirective implements OnInit {
  @Input() trigger: HTMLElement;

  private isCollapsed = true;
  private element: HTMLElement;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    this.element = this.el.nativeElement;
    this.renderer.setStyle(this.element, 'height', 0 + 'px');

    this.trigger.addEventListener('click', () => {
      this.isCollapsed ? this.expand() : this.collapse();
      this.isCollapsed = !this.isCollapsed;
    });
  }

  collapse() {
    const sectionHeight = this.element.scrollHeight;

    const elementTransition = this.element.style.transition;
    this.renderer.setStyle(this.element, 'transition', '');

    requestAnimationFrame(() => {
      this.renderer.setStyle(this.element, 'height', sectionHeight + 'px');
      this.renderer.setStyle(this.element, 'transition', elementTransition);

      requestAnimationFrame(() => {
        this.renderer.setStyle(this.element, 'height', 0 + 'px');
      });
    });
  }

  expand() {
    const sectionHeight = this.element.scrollHeight;
    this.renderer.setStyle(this.element, 'height', sectionHeight + 'px');

    this.element.addEventListener('transitionend', function transitionEnd(e) {
      this.removeEventListener('transitionend', transitionEnd);
      this.style.height = null;
    });
  }
}
